<template>
  <div
    class="modal fade text-xs-left"
    id="modalEq"
    tabindex="-1"
    v-if="showForm"
  >
    <div
      class="modal-dialog"
      role="document"
      style="min-width: 50vw; max-width: 98vw"
    >
      <div class="modal-content">
        <div class="card-header" style="border-radius: 0.27rem">
          <h4 class="card-title">{{ title }}</h4>
          <div class="heading-elements">
            <button
              type="button"
              id="closeBtn"
              ref="closeModalEq"
              class="btn btn-warning"
              data-dismiss="modal"
              @click="close()"
            >
              <!--<span aria-hidden="true">&times;</span>-->
              <i class="icon-cross" style="color: white"></i>
            </button>
          </div>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="input-group">
                <input
                  class="form-control border-primary"
                  type="text"
                  id="typeFltr"
                  v-model="filterStr"
                  v-on:keyup.enter="findStr()"
                />

                <div
                  class="input-group-append"
                  v-if="filterStr.length > 1 || hidepagin"
                >
                  <button
                    type="button"
                    class="btn btn-secondary btn-round"
                    @click="clearFind()"
                  >
                    <i class="icon-cross"></i>
                  </button>
                </div>

                <div class="input-group-append">
                  <button
                    type="button"
                    class="btn btn-primary btn-round"
                    @click="findStr()"
                  >
                    <i class="icon-search4 font-medium-4"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-12 mb-1" v-if="selectedFltr != null">
              <span>{{ $t("equipm.titles.findBy") }} </span>
              <div class="tag tag-warning hand" @click="showHFltr = !showHFltr">
                {{ $t(selectedFltr.title) }}
                <a class="dropdown-toggle" style="color: white"></a>
              </div>
              <div class="dropdown-menu" v-if="showHFltr">
                <button
                  class="dropdown-item hand"
                  type="button"
                  v-for="(item, index) in headerFilter"
                  :key="index"
                  @click="
                    selectedFltr = item;
                    showHFltr = false;
                  "
                >
                  {{ $t(item.title) }}
                </button>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div
                class="table-responsive"
                style="max-height: 68vh; overflow-y: auto"
              >
                <table class="table table-hover mb-0" cellspacing="0">
                  <thead>
                    <tr>
                      <th style="vertical-align: middle"></th>
                      <th class="text-truncate" style="vertical-align: middle">
                        {{ $t("equipm.table.nameEq") }}
                        <!-- <a @click="sortData(headerSort.name)"><i :class="headerSort.name.class"></i></a> -->
                      </th>
                      <th class="text-truncate" style="vertical-align: middle">
                        {{ $t("equipm.table.serNumber") }}
                        <!-- <a @click="sortData(headerSort.code)"><i :class="headerSort.code.class"></i></a> -->
                      </th>
                      <th class="text-truncate" style="vertical-align: middle">
                        {{ $t("tasks.table.address2") }}
                        <!-- <a @click="sortData(headerSort.place)"><i :class="headerSort.place.class"></i></a> -->
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(eq, index) in listFiltered"
                      :key="index"
                      @click="clickEq(eq)"
                    >
                      <td class="text-truncate">
                        <a class="">
                          <i
                            :class="[
                              eq.checked
                                ? 'icon-checkbox-checked'
                                : 'icon-checkbox-unchecked',
                            ]"
                          ></i>
                        </a>
                      </td>
                      <td :data-title="$t('equipm.table.nameEq')">
                        <div v-if="eq.externallyName != null">
                          <span
                            class="tag tag-warning"
                            style="white-space: pre-wrap"
                            >{{ eq.externallyName }}</span
                          ><br />
                        </div>
                        {{ eq.Goods }}
                      </td>
                      <td :data-title="$t('equipm.table.serNumber')">
                        <div v-if="eq.mainSerial != null">
                          <span
                            style="font-size: 0.8rem"
                            class="tag tag-warning hand"
                            >{{ eq.mainSerial }}</span
                          ><br />
                        </div>
                        {{ eq.SerialNumber }}
                      </td>
                      <td :data-title="$t('tasks.table.address2')">
                        {{ eq.Adress }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="" style="text-align: center" v-if="!hidepagin">
                  <ul class="pagination">
                    <li class="page-item" v-if="pageNumber > 0">
                      <a class="page-link" @click="changePage(pageNumber - 1)"
                        ><i class="icon-arrow-left2"></i
                      ></a>
                    </li>

                    <li
                      class="page-item"
                      v-bind:class="{ active: pageNumber == page - 1 }"
                      v-for="(page, index) in pages"
                      :key="index"
                    >
                      <a
                        v-if="page != '...'"
                        class="page-link"
                        @click="changePage(page - 1)"
                        >{{ page }}</a
                      >
                      <a v-else class="page-link" :id="index">{{ page }}</a>
                    </li>

                    <li class="page-item" v-if="pageNumber < pageCount - 1">
                      <a class="page-link" @click="changePage(pageNumber + 1)"
                        ><i class="icon-arrow-right2"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="modal-footer"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modalEq",
  data() {
    return {
      result: null,

      showForm: false,
      //filtering
      selectedEq: [],
      listEquipment: [],
      filterStr: "",

      hidepagin: true,

      showHFltr: false,
      headerFilter: [
        { field: 1, title: "equipm.table.serNumber" },
        { field: 2, title: "equipm.table.location" },
        { field: 3, title: "equipm.table.nameEq" },
      ],
      selectedFltr: { field: 1, title: "equipm.table.serNumber" },

      //pagination
      pageNumber: 0,
      size: 10,
      paggSize: 5,
      countListLoad: 10,
      pageCount: null,

      headerSort: {
        active: {
          boolDir: false,
          field: "active",
          class: "icon-sort-amount-desc",
        }, //dt activate
        name: { boolDir: true, field: "name", class: "icon-sort-amount-asc" }, //name eq
        place: { boolDir: true, field: "place", class: "icon-sort-amount-asc" }, //location
        code: { boolDir: true, field: "code", class: "icon-sort-amount-asc" }, //serial
      },
      selectSort: {
        field: "active",
        direction: "УБЫВ",
      },
    };
  },
  components: {},
  props: {
    title: { type: String, required: false, default: "" },
    preSelected: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  emits: ["onClose"],
  methods: {
    clickEq(item) {
      item.checked = !item.checked;
      let ind_find = null;

      for (let i = 0; i < this.selectedEq.length; i++) {
        if (item.SerialNumber == this.selectedEq[i].serial) {
          //serial
          ind_find = i;
          break;
        }
      }

      if (ind_find != null) {
        if (!item.checked) {
          this.selectedEq.splice(ind_find, 1);
        }
      } else {
        if (item.checked) {
          this.selectedEq.push({
            serial: item.SerialNumber,
            address: item.Adress,
          });
        }
      }
    },
    clearSelected() {
      for (let i = 0; i < this.listEq.length; i++) {
        this.listEq[i].checked = false;
      }
      this.selectedEq = [];
    },
    getEqList(start, finish) {
      this.listEquipment = [];
      this.selectedEq = [];

      return new Promise((resolve, reject) => {
        let dataRequest = {
          guidClient: this.$store.state.guidClient,
          type: 100,
          status: 100,
          start: start,
          finish: finish,
          sort: this.selectSort,
        };

        this.makeQuery("/service/getListProductPage", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            let resData = result.arrayProduct;

            if (result.countPage != undefined && this.countPage == null) {
              this.pageCount = Math.ceil(result.countPage / this.countListLoad);
            }
            let dt_now = new Date();
            let dt1, days_diff;

            for (let i = 0; i < resData.length; i++) {
              resData[i].guarantee = false;
              resData[i].daysGar = 0;
              resData[i].checked = false;
              resData[i].SerialNumber = resData[i].SerialNumber.trim();

              if (resData[i].Goods == "" || resData[i].Goods == null) {
                resData[i].Goods =
                  resData[i].ProductType + " (" + resData[i].SerialNumber + ")";
              }

              resData[i].DateCreate = this.dtFormat(resData[i].DateCreate);
              resData[i].DateShipping = this.dtFormat(resData[i].DateShipping);

              if (
                resData[i].StartGuarantee != null &&
                resData[i].StartGuarantee != ""
              ) {
                resData[i].StartGuarantee = +new Date(
                  resData[i].StartGuarantee
                );

                dt1 = resData[i].StartGuarantee;
                days_diff = Math.ceil(
                  Math.abs(dt_now - dt1) / (1000 * 3600 * 24)
                );
                resData[i].daysGar = this.guarantee - days_diff;
                if (days_diff < this.guarantee) {
                  resData[i].guarantee = true;
                }
                resData[i].StartGuarantee = this.dtFormat(
                  resData[i].StartGuarantee
                );
              }
              resData[i].titleType = resData[i].ProductType;
              for (let j = 0; j < this.$store.state.eq_type.length; j++) {
                if (
                  this.$store.state.eq_type[j].name == resData[i].ProductType
                ) {
                  resData[i].ProductTypeId = this.$store.state.eq_type[j].id;
                  break;
                }
              }
              if (resData[i].Adress == "Соответствие") {
                resData[i].Adress = null;
              }

              if (this.isValid(resData[i].mainSerial)) {
                resData[i].mainSerial = resData[i].mainSerial.trim();
              } else {
                resData[i].mainSerial = null;
              }
              if (this.isValid(resData[i].externallyName)) {
                resData[i].externallyName = resData[i].externallyName.trim();
              } else {
                resData[i].externallyName = null;
              }

              this.listEquipment.push(resData[i]);

              for (let j = 0; j < this.preSelected.length; j++) {
                if (
                  this.listEquipment[i].SerialNumber ==
                  this.preSelected[j].serial
                ) {
                  this.selectedEq.push({
                    serial: this.preSelected[j].serial,
                    address: resData[i].Adress,
                  });
                  this.listEquipment[i].checked = true;
                  break;
                }
              }
            }
            this.hidepagin = false;

            return resolve();
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      });
    },
    showFrom() {
      this.selectedEq = [];
      return new Promise((resolve, reject) => {
        this.getEqList(0, this.countListLoad).then((result) => {
          this.showForm = true;
          return resolve();
        });
      });
    },
    close() {
      this.showForm = true;
      this.$emit("onClose", { result: this.selectedEq });
    },
    changePage(newPage) {
      this.getEqList(
        newPage * this.countListLoad,
        newPage * this.countListLoad + this.countListLoad
      ).then((result) => {
        this.pageNumber = newPage;
      });
    },
    findStr() {
      if (this.filterStr.length > 4) {
        //зробити пошук запит і те, що вернеться
        let dataRequest = {
          guidClient: this.$store.state.guidClient,
          userGuid: this.$store.getters.getGuidUser,
          filter: this.filterStr,
          findBy: this.selectedFltr.field,
        };
        this.makeQuery("/service/listfilterproduct", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            let resData = result;
            let dt_now = new Date();
            let dt1, days_diff;
            let lat = null,
              lng = null;

            if (resData.length > 0) {
              for (let i = 0; i < resData.length; i++) {
                lat = null;
                lng = null;

                resData[i].guarantee = false;
                resData[i].daysGar = 0;
                resData[i].checked = false;

                resData[i].DateCreate = this.dtFormat(resData[i].DateCreate);
                resData[i].DateShipping = this.dtFormat(
                  resData[i].DateShipping
                );

                if (
                  resData[i].StartGuarantee != null &&
                  resData[i].StartGuarantee != ""
                ) {
                  resData[i].StartGuarantee = +new Date(
                    resData[i].StartGuarantee
                  );

                  dt1 = resData[i].StartGuarantee;
                  days_diff = Math.ceil(
                    Math.abs(dt_now - dt1) / (1000 * 3600 * 24)
                  );
                  resData[i].daysGar = this.guarantee - days_diff;
                  if (days_diff < this.guarantee) {
                    resData[i].guarantee = true;
                  }
                  resData[i].StartGuarantee = this.dtFormat(
                    resData[i].StartGuarantee
                  );
                }
                resData[i].titleType = resData[i].ProductType;

                if (
                  resData[i].coordinate != undefined &&
                  resData[i].coordinate != "" &&
                  resData[i].coordinate != null
                ) {
                  resData[i].coordinate = resData[i].coordinate.replace(
                    ", ",
                    ":"
                  );
                  var coord = resData[i].coordinate.split(":");

                  if (coord[0]) {
                    if (coord[0].indexOf(",") > -1) {
                      lat = coord[0].replace(",", ".");
                    } else {
                      lat = coord[0];
                    }
                    lat = parseFloat(lat);
                  }

                  if (coord[1]) {
                    if (coord[1].indexOf(",") > -1) {
                      lng = coord[1].replace(",", ".");
                    } else {
                      lng = coord[1];
                    }
                    lng = parseFloat(lng);
                  }
                  resData[i].coordinate = { lat: lat, lng: lng };
                } else {
                  resData[i].coordinate = { lat: null, lng: null };
                }
                if (resData[i].Adress == "Соответствие") {
                  resData[i].Adress = null;
                  resData[i].coordinate = { lat: null, lng: null };
                }

                if (this.isValid(resData[i].mainSerial)) {
                  resData[i].mainSerial = resData[i].mainSerial.trim();
                } else {
                  resData[i].mainSerial = null;
                }
                if (this.isValid(resData[i].externallyName)) {
                  resData[i].externallyName = resData[i].externallyName.trim();
                } else {
                  resData[i].externallyName = null;
                }
              }
              this.pageNumber = 0;
              this.listEquipment = resData;
              this.hidepagin = true;
            } else {
              this.showNotification(
                "custom-info",
                this.filterStr,
                "Not found!"
              );
            }
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },
    clearFind() {
      this.filterStr = "";

      if (this.hidepagin) {
        this.pageCount = null;
        this.getEqList(0, this.countListLoad).then((result) => {
          this.pageNumber = 0;
        });
      }
    },
    sortData(item) {
      if (item.field == this.selectSort.field) {
        item.boolDir = !item.boolDir;
      } else {
        item.boolDir = false;
      }

      if (item.boolDir) {
        this.selectSort.direction = null;
        item.class = "icon-sort-amount-asc";
      } else {
        this.selectSort.direction = "УБЫВ";
        item.class = "icon-sort-amount-desc";
      }

      this.selectSort.field = item.field;
      this.changePage(this.pageNumber);
    },
  },
  computed: {
    listFiltered: function () {
      /*this.pageNumber = 0;
            let find = (this.filterStr.toLowerCase()).trim();
            
            return this.listEquipment.filter(item => {
                if( find == '' || ((item.SerialNumber != null) && (item.SerialNumber.toLowerCase().indexOf(find) !== -1))
                                || ((item.Adress != null) && (item.Adress.toLowerCase().indexOf(find) !== -1)) ){
                    return item;
                }

            });*/
      return this.listEquipment;
    },
    pages: function () {
      let arr = [];
      let max_pages = this.pageCount;
      for (let i = 0; i < max_pages; i++) {
        arr[i] = i + 1;
      }
      let divider = Math.trunc(this.paggSize / 2);
      let start = this.pageNumber - divider;
      let end = this.pageNumber + divider + 1;
      if (start < 0) {
        start = 0;
      }
      let final_arr = arr.slice(start, end);
      if (start + 1 > arr[0]) {
        final_arr.unshift("...");
        final_arr.unshift(1);
      }
      if (end < arr[arr.length - 1]) {
        final_arr.push("...");
      }
      //add last page

      if (this.pageNumber + 1 + divider < max_pages) {
        final_arr.push(max_pages);
      }
      return final_arr;
    },
  },
  mounted() {},
  beforeDestroy() {
    this.$root.$off();
  },
  watch: {},
  created() {
    $(document).on("click", "#modalEq", function (e) {
      e.preventDefault();
      var modalDialog = $(e.target).find(".modal-dialog");

      if (modalDialog != null) {
        try {
          var xOffset = modalDialog.offset().left;
          var yOffset = modalDialog.offset().top;

          if (
            e.pageX < xOffset ||
            e.pageX > xOffset + modalDialog.width() ||
            e.pageY < yOffset ||
            e.pageY > yOffset + modalDialog.height()
          ) {
            //console.log('поза межами');
            //$refs.closeQR.click()
            document.getElementById("closeBtn").click();
          }
        } catch (error) {}
      }
    });
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/modalEq.vue